import { useQuery } from '@tanstack/react-query';

import { TSDData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useTSD = (id: string) =>
  useQuery({
    queryKey: ['temporary-storage', id],
    queryFn: async (): Promise<TSDData> => {
      try {
        const result = await apiClient.tsd.retrieveTsd.query({ params: { id } });
        if (result.status !== 200) throw result.body;
        return result.body.data.tsd;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch TSD details');
        throw error;
      }
    },
    enabled: Boolean(id),
  });
